import format from 'string-format';

import { getFromObjWithString } from '@resn/gozer-misc';
import loadJson from '@resn/gozer-loading/loaders/load-json';

const getFom = (value, path, defaultValue) => {
    return String(path)
        .split('.')
        .reduce((acc, v) => {
            try {
                acc = acc[v] || defaultValue;
            } catch (e) {
                return defaultValue;
            }
            return acc;
        }, value);
};

let copy = {};

const getCopyValue = (from, id, args) => {
    const values = { br: '<br />', ...args };

    const val = getFromObjWithString(from, id);

    if (val) {
        if (typeof val !== 'string') {
            // if str is an array/object
            Object.entries(val).forEach(([key, value]) => {
                if (typeof value === 'string') {
                    val[key] = format(value, values);
                }
            });

            return val;
        }

        return format(val, values);
    }

    return null;
};

const CopyValue = ({ id, args }) => {
    const val = getCopyValue(copy, id, args);

    if (val) return val;

    console.warn(`WARNING: '${id}' copy not found!`);

    return '';
};

const hasCopyFor = (id) => getCopyValue(copy, id);

const setCopy = (value) => {
    copy = value;
};
const getCopy = () => copy;

const load = async (url) => {
    const copy = await loadJson(url);
    setCopy(copy);
};

const get = (id, args) => CopyValue({ id, args });

const Copy = {
    setCopy,
    getCopy,
    hasCopyFor,
    get,
    load,
};

export default Copy;
